import { CbInputModule } from '@chubb/ui-components/cb-input';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EmailFormComponent } from './email-form.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppAnalyticsModule } from '../../directives/app-analytics.module';
import { NotificationsModule } from '../notifications/notifications.module';
@NgModule({
    imports: [
        CommonModule,
        CbInputModule,
        ReactiveFormsModule,
        FormsModule,
        AppAnalyticsModule,
        NotificationsModule,
    ],
    declarations: [EmailFormComponent],
    exports: [EmailFormComponent],
})
export class EmailFormModule {}
